/**
 * Removes specified characters from both ends of a string.
 * @param value The string to trim.
 * @param what A string containing the characters to remove.
 * @returns The trimmed string.
 */
export default function trim(value: string, what: string): string {
	let start = 0;
	let end = value.length;

	while (start < end && what.includes(value[start])) {
		start += 1
	}

	while (end > start && what.includes(value[end - 1])) {
		end -= 1
	}

	return start > 0 || end < value.length ? value.substring(start, end) : value
}
